import { current } from '@reduxjs/toolkit';
import { TicketingApiResponseStatus } from '@Src/store/types';

export function apiLoading(state: any, action: any) {
  state.status = TicketingApiResponseStatus.loading;
}

export function apiRejected(state: any, action: any) {
  state.status = TicketingApiResponseStatus.failed;
  console.error(`current state`, current(state));
  console.error(JSON.stringify(action.error));
}
